import axios from 'axios'
const state = {
    loading: false,
    tableOptions: {
        tableHeaders: [],
        tableData: [],
        accessTableData: [],
        loading: false,
        tableMeta: {
            total: 10,
            page: 1,
        },
    },
    newParent: {
        listParent: [],
        parent_relation: null,
        lives_with: null,
    },
    //  {
    //     information: {
    //         title: {
    //             description: "title",
    //             value: "",
    //         },
    //         first_name: {
    //             description: "first name",
    //             value: "",
    //         },
    //         last_name: {
    //             description: "last name",
    //             value: "",
    //         },
    //         full_address: {
    //             description: "full address",
    //             value: "",
    //         },
    //         post_code: {
    //             description: "post code",
    //             value: "",
    //         },
    //         mobile_number: {
    //             description: "mobile number",
    //             value: "",
    //         },
    //         work_number: {
    //             description: "work number",
    //             value: "",
    //         },
    //         home_number: {
    //             description: "home number",
    //             value: "",
    //         },
    //         email: {
    //             description: "email",
    //             value: "",
    //         },
    //         nationality: {
    //             description: "nationality",
    //             value: "",
    //         },
    //         origin: {
    //             description: "origin",
    //             value: "",
    //         },
    //         occupation: {
    //             description: "occupation",
    //             value: "",
    //         },
    //     }
    // },
    parent: null,
}
const getters = {
      getTableOptions(state) {
          return state.tableOptions
      },
      getLoadingStatus(state) {
        return state.loading;
      },
      getParentData(state) {
        return state.parent;
      },
      getNewParentData(state) {
        return state.newParent;
      },
}
const mutations = {
    setLoading(state, status) {
        state.tableOptions.loading = status
    },
    setLoadingStatus(state, status) {
        state.loading = status;
    },
    setParentInformation(state, parentInfo) {
        state.parent.information.name = `${parentInfo.first_name} ${parentInfo.last_name}`;
        // state.parent.image = parentInfo.user.image;
        state.parent.sub_account = parentInfo.user?.sub_account.id;
        state.parent.user_id = parentInfo.user?.id;
        state.parent.account_id = parentInfo.user?.sub_account.account_id;
        state.parent.information.phone.value = parentInfo.mobile_number;
        state.parent.information.username.value = parentInfo.user?.username;
        state.parent.information.password.value = parentInfo.user?.password;
        state.parent.information.whatsapp_number.value = parentInfo.whatsapp_number;
        state.parent.information.address.value = parentInfo.full_address;
        state.parent.information.title.value = parentInfo.title;
        state.parent.children = parentInfo.children;
        state.parent.id = parentInfo.id;
      },
      setNewParentInformation(state, parentInfo) {
        state.newParent.listParent = parentInfo.data;
        state.newParent.parent_relation = parentInfo.parent_relation;
        state.newParent.lives_with = parentInfo.lives_with;

        // state.parent.information.title.value = parentInfo.title;
        // state.parent.information.first_name.value = parentInfo.first_name;
        // state.parent.information.last_name.value = parentInfo.last_name;
        // state.parent.information.full_address.value = parentInfo.full_address;
        // state.parent.information.post_code.value = parentInfo.post_code;
        // state.parent.information.mobile_number.value = parentInfo.mobile_number;
        // state.parent.information.work_number.value = parentInfo.work_number;
        // state.parent.information.home_number.value = parentInfo.home_number;
        // state.parent.information.email.value = parentInfo.email;
        // state.parent.information.nationality.value = parentInfo.nationality;
        // state.parent.information.origin.value = parentInfo.origin;
        // state.parent.information.occupation.value = parentInfo.occupation;
      },
    setTableData(state, tableInfo) {
        state.tableOptions.tableHeaders = tableInfo.tableHeaders
        state.tableOptions.tableData = tableInfo.tableData
        state.tableOptions.accessTableData = tableInfo.accessTableData
        state.tableOptions.tableMeta.total = tableInfo.tableMeta.total
        state.tableOptions.tableMeta.page = tableInfo.tableMeta.page
    }
}
const actions = {
    initParent(){
      state.parent = {
        id: null,
        image: null,
        sub_account: null,
        user_id: null,
        account_id: null,
        children: [],
        information: {
          title: {
            desc: "His title is father/mother/grandfather...",
            value: "",
          },
          name: {
            desc:"name",
            value:""
          },
          address: {
            desc: "Full Address",
            value: ""
          },
          phone: {
            desc:"phone number",
            value:""
          },
          username: {
            desc:"user name",
            value:""
          },
          password: {
            desc:"Password",
            value:""
          },
          whatsapp_number: {
            desc: "Whatsapp Number",
            value:"",
          },
          work_number: {
            desc: "Work Number",
            value: "",
          },
          home_number: {
            desc: "home_number",
            value: "",
          },
          email: {
            desc: "hr.employee.email",
            value: "",
          },
          nationality: {
            desc: "nationality",
            value: "",
          },
          origin: {
            desc: "Origin",
            value: "",
          },
          occupation: {
            desc: "Occupation",
            value: "",
          },   
        }
      };
    }  ,
    async fetchParents({ commit }, payload) {
        try {
            commit('setLoading', true)
            let params = {
                size: 10,
                paginated: true,
            };
            for (let key in payload.params) {
                if (payload.params[key]) {
                    params[key] = payload.params[key]
                }
            }
            const response = await axios.get('/student-parent', {
                params,
            });
            let tableHeaders = []
            let accessTableData = []
            // if (payload.endPoint == '/parent') {
            tableHeaders = ["name", "phone number", "Full Address", "child", "password", "settings"]
            accessTableData = [ ["name"], ["mobile_number"], ["full_address"], ["children"], ["user","password"]]
            // }
            // else {
            //     tableHeaders = ["Id", "الاسم", "اسم المستخدم", "الاعدادات"]
            //     accessTableData = [["id"], ["name"], ["username"]]
            // }
            commit('setTableData', {
                tableHeaders,
                tableData: response.data.data.map((el)=>({...el,name: `${el.first_name} ${el.last_name}`})),
                accessTableData,
                tableMeta: {
                    total: response.data.meta.total,
                    page: response.data.meta.current_page,
                },
            })
        } catch (err) {
            console.log('err', err);
        } finally {
            commit('setLoading', false)
        }
    },
    async fetchParent({ commit, state }, parentId) {
        try {
          console.log(parentId);
          commit("setLoadingStatus", true);
          const response = await axios.get(`/student-parent/${parentId}`);
          let responseData = response.data.data;
          commit("setParentInformation", responseData);
        } catch (err) {
          console.log("errrr", err);
        } finally {
          commit("setLoadingStatus", false);
        }
      },
      async fetchNewParent({ commit, state }, studentId) {
        try {
          commit("setLoadingStatus", true);
          const response = await axios.get(`/student-parent?student_id=${studentId}`);
          let responseData = response.data;
          commit("setNewParentInformation", responseData);
        } catch (err) {
          console.log("errrr", err);
        } finally {
          commit("setLoadingStatus", false);
        }
      },
}


export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true
}